module.exports = __webpack_public_path__ + "assets/6a29305d06e1da56a96725c9b05a7b7f.mp3";